import angular from "angular";
import { AdpConfigEditorModule } from "./adp-config-editor/adp-config-editor.module";
import { AdpConfigListModule } from "./adp-config-list/adp-config-list.module";
import { AdpConfigRoutingModule } from "./adp-config-routing.module";

export const AdpConfigModule = angular
    .module("apex.adpConfig", [
        AdpConfigEditorModule,
        AdpConfigListModule,
        AdpConfigRoutingModule
    ])
    .name;
